// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0003 3.57339C13.0265 7.04273 14.9123 10.0695 17.7103 11.7062C14.0995 10.7591 11.3743 7.62526 11.0355 3.80541C11.0211 3.80517 11.0067 3.80495 10.9923 3.80477C10.3318 3.79621 9.60889 3.84736 8.90924 3.9476C8.21144 4.04759 7.51241 4.19989 6.90495 4.40331C6.32977 4.5959 5.71185 4.87424 5.2932 5.29289L4.71351 5.87258L6.80029 9.00275C5.98691 10.2591 5.20065 11.7141 5.03302 14.0575C4.84375 14.0766 4.63389 14.1023 4.41075 14.1366C3.55384 14.2685 2.37934 14.5455 1.4456 15.1679L0.430664 15.8446L8.15573 23.5696L8.83235 22.5547C9.39533 21.7102 9.70212 20.9649 9.85588 20.1961C9.93856 19.7827 9.97393 19.3732 9.98905 18.9649C11.6933 18.8476 13.8257 18.42 15.6011 17.4421L16.7209 19.6918L17.7038 18.7088C18.8923 17.5203 19.5832 16.1272 19.9767 15.0562C20.1749 14.5168 20.3017 14.048 20.3796 13.7102C20.4064 13.5941 20.4275 13.4931 20.4438 13.4095C21.7293 11.65 22.1957 9.59882 22.3087 7.85937C22.4261 6.05294 22.169 4.48803 21.9654 3.73802L21.8011 3.13295L21.1849 3.01719C18.073 2.43258 15.2739 2.50377 13.0003 3.57339ZM19.4174 6.49726L18.0002 7.91415L16.5834 6.49726L18.0002 5.08026L19.4174 6.49726Z"}}]};

const FishFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fish-filled',
    ref,
    icon: element,
  },
));

FishFilledIcon.displayName = 'FishFilledIcon';

export default FishFilledIcon;
